export default "__VITE_ASSET__Mc7rvNDu__"